import React from "react";
import { BtnAlternative, BtnPrimary } from "../../../share/buttons/Btn";
import DashCard from "../../../share/cards/DashCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import DashCrousel from "../../../../Assets/Image/png/dashCrousel.png";
import Slider from "react-slick";

import "swiper/scss";
import "swiper/scss/navigation";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
};

// mySwiper = new SwiperSlide(("mySwiper") , {
//     console.log("Test");
// });

// mySwiper.on("slideChange", function () {
//     console.log("", mySwiper.realIndex);
// });

const DashboardCarousel = ({ courses, className, setSliderIndex }) => {
    const setSlideIndex = (slide) => {
        console.log(slide.realIndex);
        setSliderIndex(slide.realIndex);
    };

    return (
        <Swiper
            modules={[Navigation]}
            spaceBetween={60}
            slidesPerView={2}
            navigation
            loop
            infinite
            className={`${className} py-4 px-8 w-full`}
            onSlideChange={(slide) => setSlideIndex(slide)}
        >
            {courses?.map((course) => {
                return (
                    <SwiperSlide className="rounded-16">
                        <DashCard
                            className="flex items-center flex-col py-10 px-12 justify-between"
                            topRight
                        >
                            <h4 className=" text-purple-dark font-bold text-sm mb-8">
                                {course.bootcamp_name}
                            </h4>
                            <div className=" mb-8 text-[1.8rem]">
                                <span className="text-gray">استاد:</span>
                                <h6 className="inline">
                                    {course.bootcamp_organizer}
                                </h6>
                            </div>
                            <div className=" mb-8 text-[1.8rem]">
                                <span className="text-gray">دسته بندی:</span>
                                <h6 className="inline">
                                    {course.bootcamp_category}
                                </h6>
                            </div>
                            <div className=" mb-8 text-[1.8rem]">
                                <span className="text-gray ml-3">وضعیت </span>
                                <h6 className="inline">
                                    {course.bootcamp_is_published
                                        ? "منتشر شده"
                                        : "پیشنویس"}
                                </h6>
                                {/* <progress
                                    className="progress w-[14.8rem] h-4 progress-primary "
                                    value={course.progress}
                                    max="100"
                                /> */}
                            </div>
                            <BtnAlternative
                                text="داشبورد دوره"
                                className="px-10 py-6 self-center"
                            />
                        </DashCard>
                    </SwiperSlide>
                );
            })}
        </Swiper>
        // <Slider {...settings}>
        //   {courses.map((course) => {
        //     return (
        //       <DashCard
        //         className="flex flex-col py-10 px-12 justify-between items-end w-full"
        //         topRight
        //       >
        //         <h4 className=" text-purple-dark font-bold text-sm mb-8">
        //           {course.title}
        //         </h4>
        //         <div className=" mb-8 text-[1.8rem]">
        //           <span className="text-gray">استاد:</span>
        //           <h6 className="inline">{course.teacher}</h6>
        //         </div>
        //         <div className=" mb-8 text-[1.8rem]">
        //           <span className="text-gray">دسته بندی:</span>
        //           <h6 className="inline">{course.category}</h6>
        //         </div>
        //         <div className=" mb-8 text-[1.8rem] flex items-center flex-row-reverse">
        //           <span className="text-gray ml-3">:میزان تکمیل دوره</span>
        //           <h6 className="inline ml-4">%{course.progress}</h6>
        //           <progress
        //             className="progress w-[14.8rem] h-4 progress-primary "
        //             style={{ direction: "rtl" }}
        //             value={course.progress}
        //             max="100"
        //           />
        //         </div>
        //         <BtnAlternative
        //           text="داشبورد دوره"
        //           className="px-10 py-6 self-center"
        //         />
        //       </DashCard>
        //     );
        //   })}
        // </Slider>
    );
};

export default DashboardCarousel;
